<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-cooperation === ccc -->
      <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
      <div class="ccc">
        <div class="ccc-box custom-item">
          <!-- 内容 -->
          <div class="custom-m-item">
            <div class="cmi-title">{{Modal.title || '合作医院'}}</div>
            <div class="cmi-cooperation">
              <template v-if="list.length">
                <div
                  class="cmi-cooperation-item"
                  v-for="(item, index) in list"
                  :key="'cmi-cooperation-' + index"
                >
                  <img :src="item.logo" v-if="item.logo" />
                  <img src="@assets/img/empty.png" v-else />
                </div>
              </template>
              <template v-else>
                <div
                  class="cmi-cooperation-item"
                  v-for="(item, index) in emptylist"
                  :key="'cmi-cooperation-empty-' + index"
                >
                  <img src="@assets/img/empty.png" />
                </div>
              </template>
            </div>
            <!-- <img src="@assets/img/template/company-component-cove-6.jpg" width="100%" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 合作伙伴
  name: "custom-company-cooperation",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "合作伙伴",
          type: 5,
          isOpen: true,
          title: "合作伙伴"
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      emptylist: [1, 1, 1, 1, 1, 1],
      list: [],
      pageSize: 6,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    Load(val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      Load: "customCompanyModule/getLoad",
      activeIndex: "customCompanyModule/getActiveIndex"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getCooperation: "companyModule/getCooperation",
      getActionType: "companyModule/getActionType"
    }),
    async init() {
      let result = await this.getCooperation(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.list = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount; 
      } 
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/partner/addpartner";
      window.open(link);
    }
  }
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .cccp {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        position: relative;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
